import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#066542",
      d: "M19.582 19.592a1 1 0 0 1 1.414 0l6.7 6.7a1.001 1.001 0 0 1-1.415 1.414l-6.7-6.7a1 1 0 0 1 0-1.414"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#066542",
      d: "M21.913 13.963a7.963 7.963 0 1 0-15.926 0 7.963 7.963 0 0 0 15.926 0m2 0c0 5.502-4.46 9.962-9.962 9.962s-9.962-4.46-9.963-9.962S8.45 4 13.951 4s9.962 4.461 9.962 9.963"
    }, null, -1)
  ]))]))
}
export default { render: render }